import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxySaffronIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./SaffronIcon-20e69185.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxySaffronIcon as P };
